import { useState, useRef, useEffect } from "react";
import { format } from "date-fns";
import {
  LocalizationProvider,
  MobileDatePicker,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';
import MoreIcon from "../../../../../media/icons/assets_light/outline-action-menu-2-active.svg";
import calenderIcon from "../../../../../media/icons/assets_light/outline-calendar-active.svg";
import clearIcon from "../../../../../media/icons/assets_light/outline-action-close-active.svg";
import eyeIcon from "../../../../../media/icons/assets_light/outline-action-view-active.svg";
import BackIcon from "../../../../../media/icons/assets_light/move-back-2.svg";
// import ExpanseIcon from "../../../../../media/icons/assets_light/outline-menu-expenses-active.svg";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useTaskContext } from "../../../../../context/TaskContext";

export default function TimeTrackingDashboard() {

  const { active_task } = useSelector(state => state.task);
  const { OnUpdateTask, isObserver } = useTaskContext()

  const [all_breakdown, set_all_breakdown] = useState(
    active_task?.hour_breakdown?.map(({ fdate, tdate, forecasted_hours, actual_hour, note, status }) => ({
      fdate: new Date(fdate),
      tdate: new Date(tdate),
      forecasted_hours,
      actual_hour,
      note,
      status,
    })) || []
  );

  useEffect(() => {
    set_all_breakdown(active_task?.hour_breakdown?.map(({ fdate, tdate, forecasted_hours, actual_hour, note, status }) => ({
      fdate: new Date(fdate),
      tdate: new Date(tdate),
      forecasted_hours,
      actual_hour,
      note,
      status,
    })) || [])
  }, [active_task?.hour_breakdown])

  const [hour_breakdown, set_hour_breakdown] = useState({
    fdate: null,
    tdate: null,
    forecasted_hours: 0,
    actual_hour: 0,
    note: '',
    status: true
  });

  const handleDateChange = (date, name) => {
    if (isObserver()) return;
    set_hour_breakdown((prev) => ({
      ...prev,
      [name]: date,
    }));
  };

  const [openMenu, setOpenMenu] = useState(null);
  const removeOptionRef = useRef(null);
  // Helper functions
  const [showDetails, setShowDetails] = useState(false);

  // REMOVE OPTION STATE
  const [openRemoveIndex, setOpenRemoveIndex] = useState(null);

  // Close popup on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (removeOptionRef.current && !removeOptionRef.current.contains(e.target)) {
        setOpenRemoveIndex(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const [all_breakdown_hour, set_all_breakdown_hour] = useState(
    active_task?.hour_breakdown?.map(({ fdate, tdate, forecasted_hours, actual_hour, note, status }) => ({
      fdate: new Date(fdate),
      tdate: new Date(tdate),
      forecasted_hours,
      actual_hour,
      note,
      status,
    })) || []
  );

  useEffect(() => {
    set_all_breakdown_hour(active_task?.hour_breakdown?.map(({ fdate, tdate, forecasted_hours, actual_hour, note, status }) => ({
      fdate: new Date(fdate),
      tdate: new Date(tdate),
      forecasted_hours,
      actual_hour,
      note,
      status,
    })) || [])
  }, [active_task?.hour_breakdown])



  const totalHours = (all_breakdown_hour || []).reduce((totals, item) => {
    totals.forecasted_hours += Number(item.forecasted_hours) || 0;
    totals.actual_hour += Number(item.actual_hour) || 0;
    totals.hours_variance = Number(item.forecasted_hours - item.actual_hour) || 0;
    return totals;
  }, { forecasted_hours: 0, actual_hour: 0, hours_variance: 0 });

  const handleAddRow = () => {
    if (isObserver()) return;
    let { fdate, tdate, forecasted_hours, actual_hour } = hour_breakdown;
    if (fdate && tdate && (forecasted_hours > 0 || actual_hour > 0)) {
      let updatedForecastedHours = Number(totalHours?.forecasted_hours) + Number(hour_breakdown.forecasted_hours);
      let updatedActualHours = Number(totalHours?.actual_hour) + Number(hour_breakdown.actual_hour);

      OnUpdateTask({
        hour_breakdown: [
          ...(all_breakdown?.map(({ fdate, tdate, forecasted_hours, actual_hour, note, status }) =>
            ({ fdate, tdate, forecasted_hours, actual_hour, note, status }))) || [],
          hour_breakdown
        ],
        forecasted_hours: updatedForecastedHours,
        actual_hours: updatedActualHours,
        hours_variance: updatedForecastedHours - updatedActualHours,
        save_type: 'hour'
      });

      // Reset the hour breakdown form
      set_hour_breakdown({ fdate: null, tdate: null, forecasted_hours: 0, actual_hour: 0, note: '', status: true });
    }
  };

  const handleRemoveRow = (v, index) => {
    if (isObserver()) return;
    setOpenMenu(null)
    const updatedCostBreakdown = [...all_breakdown];
    updatedCostBreakdown.splice(index, 1);

    let forecasted_hours = Number(totalHours.forecasted_hours) - Number(v.forecasted_hours);
    let actual_hour = Number(totalHours.actual_hour) - Number(v.actual_hour);
    OnUpdateTask({
      hour_breakdown: [
        ...(updatedCostBreakdown?.map(({ fdate, tdate, forecasted_hours, actual_hour, note, status }) =>
          ({ fdate, tdate, forecasted_hours, actual_hour, note, status }))) || []
      ],
      forecasted_hours: forecasted_hours,
      actual_hours: actual_hour,
      hours_variance: Number(forecasted_hours - actual_hour),
      save_type: 'hour'
    });
  };

  const handleShowDetails = () => {
    if (active_task?.end_date) {
      setShowDetails(true)
    } else {
      toast.error("Please select due date before adding track hour.")
    }
  }


  return (
    <div className="dark:bg-surface-dark-2 bg-white min-h-full">
      {/* First View - Summary Card */}
      {!showDetails && (
        <div className="">
          {/* Header */}
          <div className="flex justify-between items-center py-3">
            <h2 className="text-[12px] font-semibold text-gray-800 dark:text-white">
              Total hours tracked
            </h2>
            <button
              onClick={handleShowDetails}
              className="flex items-center gap-1 px-2.5 py-1.5 rounded-full text-[11px] font-medium transition-all active:scale-95 bg-teal-600 text-white shadow-sm shadow-teal-500/25 active:bg-teal-600"
            >
              <span className="text-[12px] leading-none">+</span>
              <span>Add time</span>
            </button>
          </div>

          {/* Summary Cards */}
          <div className="grid grid-cols-2 gap-2 mb-3">
            {/* Forecasted Hours Card */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 rounded-xl p-3 border border-blue-200 dark:border-blue-800">
              <div className="flex items-center gap-1.5 mb-1.5">
                <div className="w-6 h-6 rounded-lg bg-blue-500 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">FH</span>
                </div>
                <span className="text-xs font-medium text-blue-600 dark:text-blue-400">Forecasted</span>
              </div>
              <p className="text-[12px] font-bold text-gray-800 dark:text-white">
                {totalHours?.forecasted_hours ? `${totalHours?.forecasted_hours} hrs` : "0 hrs"}
              </p>
            </div>

            {/* Actual Hours Card */}
            <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900/20 dark:to-emerald-800/20 rounded-xl p-3 border border-emerald-200 dark:border-emerald-800">
              <div className="flex items-center gap-1.5 mb-1.5">
                <div className="w-6 h-6 rounded-lg bg-emerald-500 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">AH</span>
                </div>
                <span className="text-xs font-medium text-emerald-600 dark:text-emerald-400">Actual</span>
              </div>
              <p className="text-[12px] font-bold text-gray-800 dark:text-white">
                {totalHours?.actual_hour ? `${totalHours?.actual_hour} hrs` : "0 hrs"}
              </p>
            </div>
          </div>

          {/* View Details Button */}
          <button
            onClick={handleShowDetails}
            className="w-full py-2.5 px-3 bg-gray-50 dark:bg-surface-dark-3 rounded-lg flex items-center justify-between border border-gray-200 dark:border-gray-700 active:bg-gray-100 dark:active:bg-surface-dark-4 transition-colors"
          >
            <div className="flex items-center gap-2">
              <div
                className="w-5 h-5 bg-gray-500 dark:bg-gray-400"
                style={{
                  WebkitMaskImage: `url(${eyeIcon})`,
                  WebkitMaskRepeat: "no-repeat",
                  WebkitMaskPosition: "center",
                  WebkitMaskSize: "contain",
                  maskImage: `url(${eyeIcon})`,
                  maskRepeat: "no-repeat",
                  maskPosition: "center",
                  maskSize: "contain",
                }}
              />
              <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                View {all_breakdown.length} time {all_breakdown.length === 1 ? 'entry' : 'entries'}
              </span>
            </div>
            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      )}

      {/* Second View - Details & Add Form */}
      {showDetails && (
        <div className="bg-white dark:bg-surface-dark min-h-full">
          {/* Sticky Header */}
          <div className="sticky top-0 z-10 bg-white dark:bg-surface-dark border-b border-gray-100 dark:border-gray-800 px-3 py-2.5">
            <div className="flex items-center gap-2">
              <button
                onClick={() => setShowDetails(false)}
                className="w-9 h-9 rounded-full bg-gray-100 dark:bg-surface-dark-2 flex items-center justify-center active:bg-gray-200 dark:active:bg-surface-dark-3 transition-colors"
              >
                <div
                  className="w-5 h-5 bg-gray-600 dark:bg-gray-300"
                  style={{
                    WebkitMaskImage: `url(${BackIcon})`,
                    WebkitMaskRepeat: "no-repeat",
                    WebkitMaskPosition: "center",
                    WebkitMaskSize: "contain",
                    maskImage: `url(${BackIcon})`,
                    maskRepeat: "no-repeat",
                    maskPosition: "center",
                    maskSize: "contain",
                  }}
                />
              </button>
              <h2 className="text-base font-semibold text-gray-800 dark:text-white">Time Details</h2>
            </div>
          </div>

          {/* Time List */}
          <div className="">
            {all_breakdown.length > 0 ? (
              <div className="space-y-2 mb-4">
                {all_breakdown.map((v, idx) => (
                  <div
                    key={idx}
                    className="bg-gray-50 dark:bg-surface-dark-2 rounded-xl p-3 border border-gray-200 dark:border-gray-800"
                  >
                    <div className="flex items-start justify-between mb-2 relative">
                      <div className="flex-1 pr-2">
                        <div className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-400">
                          <span>{format(v.fdate, "dd MMM yyyy")}</span>
                          <span className="text-gray-400">→</span>
                          <span>{format(v.tdate, "dd MMM yyyy")}</span>
                        </div>
                      </div>
                      {!isObserver() && <button
                        onClick={() => setOpenMenu((prev) => (prev === idx ? null : idx))}
                        className="w-7 h-7 rounded-full bg-white dark:bg-surface-dark-3 flex items-center justify-center shadow-sm active:bg-gray-100 dark:active:bg-surface-dark-4 transition-colors"
                      >
                        <div className="w-3.5 h-3.5 bg-gray-500 dark:bg-gray-400"
                          style={{
                            WebkitMaskImage: `url(${MoreIcon})`,
                            WebkitMaskRepeat: "no-repeat",
                            WebkitMaskPosition: "center",
                            WebkitMaskSize: "contain",
                            maskImage: `url(${MoreIcon})`,
                            maskRepeat: "no-repeat",
                            maskPosition: "center",
                            maskSize: "contain",
                          }}
                        />
                      </button>}
                      {/* Remove Action Sheet - Rendered at card level */}
                      {openMenu === idx && (
                        <div
                          className="absolute right-2 top-6 z-[100] flex items-end justify-center bg-black/50 w-36"
                          onClick={() => setOpenMenu(null)}
                        >
                          <div
                            ref={removeOptionRef}
                            className="bg-white dark:bg-surface-dark-2 w-full max-w-sm rounded-xl overflow-hidden shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button onClick={() => handleRemoveRow(v, idx)} className="w-full py-2 text-red-500 font-medium text-[12px] active:bg-red-50 dark:active:bg-red-900/20 transition-colors" >
                              Remove
                            </button>
                            <div className="h-1.5 bg-gray-100 dark:bg-gray-800" />
                            <button onClick={() => setOpenMenu(null)} className="w-full py-2 text-gray-700 dark:text-gray-300 font-medium text-[12px] active:bg-gray-50 dark:active:bg-surface-dark-3 transition-colors" >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-2">
                        <p className="text-xs text-blue-600 dark:text-blue-400 mb-0.5">Forecasted</p>
                        <p className="text-[12px] text-gray-600 font-bold dark:text-white">
                          {v.forecasted_hours} hrs
                        </p>
                      </div>
                      <div className="bg-emerald-50 dark:bg-emerald-900/20 rounded-lg p-2">
                        <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-0.5">Actual</p>
                        <p className="text-[12px] text-gray-600 font-bold dark:text-white">
                          {v.actual_hour} hrs
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8 mb-4">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 dark:bg-surface-dark-2 flex items-center justify-center">
                  <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <p className="text-gray-500 dark:text-gray-400 text-xs">No time entries yet</p>
              </div>
            )}

            {/* Add New Time Form */}
            <div className="bg-gray-50 dark:bg-surface-dark-2 rounded-xl p-3 border border-gray-200 dark:border-gray-800 relative">
              <h3 className="text-[12px] text-gray-600 font-bold dark:text-white mb-3">Add New Time</h3>

              {/* Date Range */}
              <div className="grid grid-cols-2 gap-2 mb-3">
                {/* From Date */}
                <div>
                  <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">
                    From
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <div className="relative">
                      <MobileDatePicker
                        value={hour_breakdown?.fdate ? new Date(hour_breakdown.fdate) : null}
                        onChange={(date) => handleDateChange(date, 'fdate')}
                        minDate={active_task?.start_date ? new Date(active_task?.start_date) : undefined}
                        maxDate={active_task?.end_date ? new Date(active_task?.end_date) : undefined}
                        format="dd MMM yyyy"
                        className="newCssForTaskNewDesign"
                        closeOnSelect
                        slots={{ textField: TextField }}
                        slotProps={{
                          textField: {
                            placeholder: "Select date",
                            fullWidth: true,
                            sx: {
                              '& .MuiInputBase-root': {
                                backgroundColor: 'transparent',
                                borderRadius: '0.5rem',
                                padding: '0.375rem 0.75rem',
                                height: '40px',
                              },
                              '& .MuiInputBase-input': {
                                fontSize: '0.75rem',
                                color: 'inherit',
                                padding: 0,
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgb(229 231 235)',
                                borderRadius: '0.5rem',
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgb(59 130 246)',
                              },
                              '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgb(59 130 246)',
                                borderWidth: '2px',
                              },
                            }
                          },
                        }}
                      />
                      <div className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center pointer-events-none">
                        <div
                          className="w-3 h-3 bg-blue-600 dark:bg-blue-400"
                          style={{
                            WebkitMaskImage: `url(${calenderIcon})`,
                            WebkitMaskRepeat: "no-repeat",
                            WebkitMaskPosition: "center",
                            WebkitMaskSize: "contain",
                            maskImage: `url(${calenderIcon})`,
                            maskRepeat: "no-repeat",
                            maskPosition: "center",
                            maskSize: "contain",
                          }}
                        />
                      </div>
                      {hour_breakdown.fdate && (
                        <button
                          onClick={() => handleDateChange(null, 'fdate')}
                          className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-gray-100 dark:bg-surface-dark-4 flex items-center justify-center"
                        >
                          <div
                            className="w-3 h-3 bg-gray-500"
                            style={{
                              WebkitMaskImage: `url(${clearIcon})`,
                              WebkitMaskRepeat: "no-repeat",
                              WebkitMaskPosition: "center",
                              WebkitMaskSize: "contain",
                              maskImage: `url(${clearIcon})`,
                              maskRepeat: "no-repeat",
                              maskPosition: "center",
                              maskSize: "contain",
                            }}
                          />
                        </button>
                      )}
                    </div>
                  </LocalizationProvider>
                </div>

                {/* To Date */}
                <div>
                  <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">
                    To
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <div className="relative">
                      <MobileDatePicker
                        value={hour_breakdown?.tdate ? new Date(hour_breakdown?.tdate) : null}
                        onChange={(date) => handleDateChange(date, 'tdate')}
                        minDate={hour_breakdown?.fdate ? new Date(hour_breakdown?.fdate) : active_task?.start_date ? new Date(active_task?.start_date) : undefined}
                        maxDate={hour_breakdown?.tdate ? new Date(hour_breakdown?.tdate) : active_task?.end_date ? new Date(active_task?.end_date) : undefined}
                        format="dd MMM yyyy"
                        className="newCssForTaskNewDesign"
                        closeOnSelect
                        slots={{ textField: TextField }}
                        slotProps={{
                          textField: {
                            placeholder: "Select date",
                            fullWidth: true,
                            sx: {
                              '& .MuiInputBase-root': {
                                backgroundColor: 'transparent',
                                borderRadius: '0.5rem',
                                padding: '0.375rem 0.75rem',
                                height: '40px',
                              },
                              '& .MuiInputBase-input': {
                                fontSize: '0.75rem',
                                color: 'inherit',
                                padding: 0,
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: hour_breakdown.tdate && hour_breakdown.fdate && hour_breakdown.tdate <= hour_breakdown.fdate
                                  ? 'rgb(239 68 68)'
                                  : 'rgb(229 231 235)',
                                borderRadius: '0.5rem',
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: hour_breakdown.tdate && hour_breakdown.fdate && hour_breakdown.tdate <= hour_breakdown.fdate
                                  ? 'rgb(239 68 68)'
                                  : 'rgb(59 130 246)',
                              },
                              '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: hour_breakdown.tdate && hour_breakdown.fdate && hour_breakdown.tdate <= hour_breakdown.fdate
                                  ? 'rgb(239 68 68)'
                                  : 'rgb(59 130 246)',
                                borderWidth: '2px',
                              },
                            }
                          },
                        }}
                      />
                      <div className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center pointer-events-none">
                        <div
                          className="w-3 h-3 bg-blue-600 dark:bg-blue-400"
                          style={{
                            WebkitMaskImage: `url(${calenderIcon})`,
                            WebkitMaskRepeat: "no-repeat",
                            WebkitMaskPosition: "center",
                            WebkitMaskSize: "contain",
                            maskImage: `url(${calenderIcon})`,
                            maskRepeat: "no-repeat",
                            maskPosition: "center",
                            maskSize: "contain",
                          }}
                        />
                      </div>
                      {hour_breakdown.tdate && (
                        <button
                          onClick={() => handleDateChange(null, 'tdate')}
                          className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-gray-100 dark:bg-surface-dark-4 flex items-center justify-center"
                        >
                          <div
                            className="w-3 h-3 bg-gray-500"
                            style={{
                              WebkitMaskImage: `url(${clearIcon})`,
                              WebkitMaskRepeat: "no-repeat",
                              WebkitMaskPosition: "center",
                              WebkitMaskSize: "contain",
                              maskImage: `url(${clearIcon})`,
                              maskRepeat: "no-repeat",
                              maskPosition: "center",
                              maskSize: "contain",
                            }}
                          />
                        </button>
                      )}
                    </div>
                  </LocalizationProvider>
                </div>
              </div>

              {/* Hours Inputs */}
              <div className="grid grid-cols-2 gap-2 mb-3">
                {/* Forecasted */}
                <div>
                  <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">
                    Forecasted (hrs)
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      placeholder="0.00"
                      name="forecasted_hours"
                      value={hour_breakdown.forecasted_hours ? hour_breakdown.forecasted_hours : ''}
                      onChange={(e) => set_hour_breakdown((prev) => ({ ...prev, forecasted_hours: Number(e.target.value) }))}
                      readOnly={isObserver()}
                      className="w-full h-10 px-3 py-2 bg-white dark:bg-surface-dark-3 border border-border-primary hover:border-border-action dark:border-gray-700 rounded-lg text-xs text-gray-800 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all pr-8"
                    />
                    <div className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                      <span className="text-blue-600 dark:text-blue-400 text-[8px] font-bold">H</span>
                    </div>
                  </div>
                </div>

                {/* Actual */}
                <div>
                  <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">
                    Actual (hrs)
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      placeholder="0.00"
                      name="actual_hour"
                      value={hour_breakdown.actual_hour ? hour_breakdown.actual_hour : ''}
                      onChange={(e) => set_hour_breakdown((prev) => ({ ...prev, actual_hour: Number(e.target.value) }))}
                      readOnly={isObserver()}
                      className="w-full h-10 px-3 py-2 bg-white dark:bg-surface-dark-3 border border-border-primary hover:border-border-action dark:border-gray-700 rounded-lg text-xs text-gray-800 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all pr-8"
                    />
                    <div className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
                      <span className="text-emerald-600 dark:text-emerald-400 text-[8px] font-bold">H</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Add Button */}
              <button
                onClick={handleAddRow}
                className={`w-full py-3 rounded-lg font-semibold text-xs transition-all active:scale-[0.98]
                    ${hour_breakdown.fdate && hour_breakdown.tdate && (hour_breakdown.forecasted_hours > 0 || hour_breakdown.actual_hour > 0) ? 'bg-teal-600 text-white shadow-md shadow-teal-500/25 active:bg-teal-600' : 'bg-gray-200 text-gray-400 cursor-not-allowed'} ${isObserver() ? 'bg-button-unactive' : ''}
                    `}
              >
                Add time entry
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
